import React, { useCallback, useEffect, useState } from "react";
import { Table, Button, Row, Col, Input, Pagination, Spin, App, Card } from "antd";
import { useNavigate } from "react-router-dom";
import { PACKAGE_REPORT, DOWNLOAD_PACKAGE_EXCEL } from "../../../apis/apis";
import moment from "moment";
import debounce from "lodash.debounce";
import CulsightPageLoader from "../../../components/CulsightPageLoader";
import { LoadingOutlined, EyeFilled, DownloadOutlined } from "@ant-design/icons";

const PackageReport = () => {
  const { notification } = App.useApp();
  const navigate = useNavigate();

  const [loader, setLoader] = useState(true);
  const [pagination_loader, set_pagination_loader] = useState(false);

  const [table_data, set_table_data] = useState([]);
  const [current_page, set_current_page] = useState(1);
  const [total_packages, set_total_packages] = useState(0);

  const [search_query_title, set_search_query_title] = useState("");
  const [page_size, set_page_size] = useState(10);

  const [download_button, set_download_button] = useState(true);

  const LIST_API = async (page = 1, size = 10, search = "") => {
    set_pagination_loader(true);

    const FORM_DATA = new FormData();
    FORM_DATA.append("page", page);
    FORM_DATA.append("per_page", size);
    FORM_DATA.append("name", search);

    const API_CALL = await PACKAGE_REPORT(FORM_DATA);

    if (API_CALL?.data?.status) {
      set_table_data(API_CALL?.data?.data);
      set_current_page(API_CALL?.data?.current_page);
      set_total_packages(API_CALL?.data?.total_packages);
    }

    set_pagination_loader(false);
    setLoader(false);
  };

  useEffect(() => {
    LIST_API(1, page_size, search_query_title);
  }, []);

  const onPaginationChange = (page, size) => {
    set_page_size(size);
    LIST_API(page, size, search_query_title);
  };


  const DOWNLOAD_REPORT_ACTION = async (package_id) => {
    const formData = new FormData();
    formData.append("package_id", package_id);

    const API_CALL = await DOWNLOAD_PACKAGE_EXCEL(formData);
    if (API_CALL?.data?.status) {
      notification.success({
        message: "Successful",
        description: "Check the Download tab for your report",
      });
    }
  };


  const fetchResultsTitle = useCallback(
    debounce((value) => {
      set_search_query_title(value);
      LIST_API(1, page_size, value);
    }, 500),
    [page_size]
  );

  const handleInput = (e) => {
    fetchResultsTitle(e.target.value);
  };

  const columns = [
    {
      title: "Created On",
      dataIndex: "created_on",
      render: (_, record) => moment(record.created_on).format("YYYY-MM-DD"),
    },
    {
      title: "Till Date",
      dataIndex: "till_date",
      render: (_, record) => moment(record.till_date).format("YYYY-MM-DD"),
    },
    {
      title: "Package Name",
      dataIndex: "package_name",
    },
    {
      title: "Total Courses",
      dataIndex: "total_courses",
    },
    {
      title: "Total Learners",
      dataIndex: "total_learners",
    },
    {
      title: "Action",
      render: (_, record) => (
        <>
          <Button
            size="small"
            variant="solid"
            color="blue"
            type="link"
            onClick={() =>
              navigate("/package-courses/" + btoa(record.package_id), {
                state: { from: "/report/package-report" },
              })
            }
          >
            <EyeFilled />
          </Button>
          <Button
            size="small"
            style={{ marginLeft: "10px" }}
            variant="solid"
            color="green"
            onClick={() => DOWNLOAD_REPORT_ACTION(record.package_id)}
            disabled={!download_button}
          >
            <DownloadOutlined />
          </Button>

        </>
      ),
    },
  ];

  return (
    <>
     

        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={24} md={18} lg={20}>
            <Input
              addonBefore={<span>Name</span>}
              onChange={handleInput}
              placeholder="Search by package name"
              size="large"
              style={{ width: "100%" }}
            />
          </Col>
        </Row>

        {loader ? (
          <CulsightPageLoader />
        ) : pagination_loader ? (
          <div style={{ textAlign: "center", padding: "60px" }}>
            <Spin indicator={<LoadingOutlined spin />} size="large" />
          </div>
        ) : (
          <>
            <Table
              columns={columns}
              pagination={false}
              dataSource={table_data}
              rowKey={(r) => r.package_id}
              style={{ marginTop: "15px" }}
            />

            <div style={{ float: "right", marginTop: "20px" }}>
              <Pagination
                current={current_page}
                total={total_packages}
                pageSize={page_size}
                showSizeChanger
                pageSizeOptions={[10, 20, 50, 100]}

                onChange={onPaginationChange}

                onShowSizeChange={(page, size) => {
                  set_page_size(size);
                  onPaginationChange(1, size);
                }}

                className="no-search-pagination"
              />

              <style>
                {`
                .no-search-pagination .ant-select-selection-search-input {
                  display: none !important;
                }
              `}
              </style>
            </div>
          </>
        )}
   </>
  );
};

export default PackageReport;
